var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCourseDetails(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0005 15.0909V3C18.0005 2.44772 17.5528 2 17.0005 2H4.90906",
    stroke: "#757575",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0914 4.90918H3C2.44772 4.90918 2 5.35689 2 5.90918V17C2 17.5523 2.44772 18 3 18H14.0914C14.6437 18 15.0914 17.5523 15.0914 17V5.90918C15.0914 5.35689 14.6437 4.90918 14.0914 4.90918Z",
    stroke: "#757575",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.36487 10.0005H10.7285",
    stroke: "#757575",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.36487 12.9097H10.7285",
    stroke: "#757575",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourseDetails);
export default __webpack_public_path__ + "static/media/courseDetails.44dddfdd67cf40dcb3fb5d42fb0b6ace.svg";
export { ForwardRef as ReactComponent };